import { render, staticRenderFns } from "./SysHelp.vue?vue&type=template&id=849c64f0&scoped=true&"
import script from "./SysHelp.vue?vue&type=script&lang=js&"
export * from "./SysHelp.vue?vue&type=script&lang=js&"
import style0 from "./SysHelp.vue?vue&type=style&index=0&id=849c64f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849c64f0",
  null
  
)

export default component.exports